<template>
  <b-button block :class="[modalTheme, 'no-wrap']" size="sm" @click="logoutPopup">Sign Out</b-button>
  <!-- <WelcomeName /> -->
  <!--
  <el-dropdown>
    <WelcomeName />
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item v-on:click="logoutPopup">Logout Popup</el-dropdown-item>
        <el-dropdown-item v-on:click="logoutRedirect">Logout Redirect</el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown> -->
</template>

<script setup lang="ts">
import { computed } from "vue";
// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

import { getToken, logout, login } from "@/config/authService";

// import { msalInstance } from "@/config/authConfig";

const modalTheme = computed(() => userStore.bModalTheme);

const logoutPopup = () => {
  logout();
  userStore.isAuthenticated = false;

  // msalInstance.logoutPopup({
  //   mainWindowRedirectUri: "/",
  // });
};

const logoutRedirect = () => {
  // msalInstance.logoutRedirect();
};
</script>
